<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Contact</p>

      <button
        class="button is-danger"
        type="button"
        @click="handleDelete"
        v-if="deletable"
      >
        <i class="material-icons">delete_forever</i>
      </button>
    </header>
    <section class="modal-card-body">
      <b-field label="First Name">
        <b-input v-model="first_name" placeholder="First Name" required>
        </b-input>
      </b-field>
      <b-field label="Last Name">
        <b-input v-model="last_name" placeholder="Last Name" required>
        </b-input>
      </b-field>
      <b-field label="Email">
        <b-input type="email" v-model="email" placeholder="Email" required>
        </b-input>
      </b-field>
      <b-field label="Phone">
        <b-input v-model="phone" placeholder="Phone" required> </b-input>
      </b-field>
      <b-field label="Role">
        <b-input v-model="role" placeholder="Role" required> </b-input>
      </b-field>
      <b-field label="LinkedIn">
        <b-input
          type="linkedin"
          v-model="linkedin"
          placeholder="LinkedIn address"
          required
        >
        </b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
      <button class="button is-success" @click="handleCallback">Save</button>
    </footer>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      first_name: "",
      last_name: "",
      email: "",
      role: "",
      phone: "",
      linkedin: "",
    };
  },
  methods: {
    handleDelete() {
      const { email } = this;
      this.$attrs.onDelete(email);
      this.$parent.close();
    },
    handleCallback() {
      const { first_name, last_name, email, role, phone, linkedin } = this;
      const contact = {
        first_name,
        last_name,
        email,
        phone,
        role,
        linkedin,
      };
      this.$parent.close();
      this.$attrs.callback(contact);
    },
  },
  created() {
    this.deletable = this.$attrs.deletable;
    this.first_name = this.$attrs.first_name;
    this.last_name = this.$attrs.last_name;
    this.email = this.$attrs.email;
    this.role = this.$attrs.role;
    this.phone = this.$attrs.phone;
    this.linkedin = this.$attrs.linkedin;
  },
};
</script>
